module.exports = __webpack_public_path__ + "static/media/1f955.612ef40f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f955.svg
// module id = 624
// module chunks = 1